import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { MessageSquare, Loader2 } from 'lucide-react';

export const SetupAssistantPanel = ({ setupQ, setSetupQ, setupAnswer, onAsk, loading }) => (
  <div className="max-w-3xl mx-auto space-y-6" data-testid="setup-assistant-panel">
    <Card className="card-tech p-8">
      <h2 className="text-2xl font-bold text-green-400 mb-2">
        <MessageSquare className="w-6 h-6 inline mr-2" /> AI Setup Assistant
      </h2>
      <p className="text-green-300 mb-6">Ask anything about deploying, configuring, or troubleshooting your Millionaire Machine instance.</p>
      <div className="space-y-4">
        <Textarea value={setupQ} onChange={e => setSetupQ(e.target.value)}
          placeholder="e.g., How do I set up PayPal sandbox credentials?"
          className="bg-black/50 border-green-500/30 text-green-300 min-h-24" rows={3} data-testid="setup-question-input" />
        <Button onClick={onAsk} disabled={loading || !setupQ} className="btn-primary w-full py-4" data-testid="setup-ask-button">
          {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Thinking...</> : 'Ask Assistant'}
        </Button>
      </div>
      {setupAnswer && (
        <div className="mt-6 p-4 bg-green-500/5 border border-green-500/20 rounded" data-testid="setup-answer">
          <h4 className="text-green-400 font-semibold mb-2">Answer:</h4>
          <div className="text-green-300 whitespace-pre-wrap leading-relaxed">{setupAnswer}</div>
        </div>
      )}
    </Card>
  </div>
);
